import { render, staticRenderFns } from "./WordExport.vue?vue&type=template&id=86a81458&"
import script from "./WordExport.vue?vue&type=script&lang=js&"
export * from "./WordExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports